module.exports = __webpack_public_path__ + "fonts/roboto-v15-latin-regular.7e367be02cd17a96d513ab74846bafb3.woff2?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module id = 913
// module chunks = 5